<script lang="ts">
  let size: number = 10;
</script>

<div
  class={`poweredBy ${$$restProps.class || ''}`}
  style={`font-size: ${size}px`}
>
  Powered By <a
    class="ravelyLink"
    href="https://ravely.io/signup"
    target="_blank">Ravely.io</a
  >
</div>

<style lang="scss">
  .poweredBy {
    text-align: center;
    color: var(--light-1);
  }

  .ravelyLink {
    color: inherit;
  }
</style>
